import { Switch, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { EVALUE } from "../../helpers/consts";

type PTextField = {
    field: string;
    evalue: EVALUE;
    enabled: boolean;
    onChange: (enabled: boolean, field: string, evalue: EVALUE, value: any) => void;
};

export default function CTextField(props: PTextField) {
    const [enabled, setEnabled] = useState(false);
    const [value, setValue] = useState();

    const onChange = (event: any) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        props.onChange(enabled, props.field, props.evalue, value);
    }, [enabled, value]);

    return (
        <Stack direction="row" spacing={1} alignItems={"center"} justifyContent='space-between'>
            <TextField size="small" variant="standard" placeholder={props.evalue === EVALUE.MIN ? "Minimum Value" : "Maximum Value"} sx={{ maxWidth: "281px" }} disabled={!enabled} onChange={onChange}></TextField>

            <Switch size="small" onChange={(_, c) => setEnabled(c)} />
        </Stack>
    );
}
